module.exports = __webpack_public_path__ + "static/img/post_7.05f0e1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/posts/post_7.png
// module id = NrSp
// module chunks = 0